import { gql } from '@apollo/client';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';

export const fetchDataFeeds = gql`
  query FetchDataFeedsQuery($id: Long!, $locale: TemplateLocaleInput) {
    templateAndSingleContent(id: $id, locale: $locale) {
      __typename
      ... on TemplateAndContent {
        dataFeedIds
      }
    }
  }
`;

export function useGetDataFeedIds(templateId: any) {
  const queryOptions = useMemo(() => {
    return { variables: { id: templateId }, skip: !templateId, fetchPolicy: 'no-cache' };
  }, [templateId]);

  // @ts-ignore
  const { data = {} } = useGraphql(fetchDataFeeds, queryOptions);
  const { templateAndSingleContent = {} } = data;
  const { dataFeedIds } = templateAndSingleContent;
  return {
    dataFeedData: dataFeedIds,
  };
}
